import RegisterTemplate from '../../components/Templates/Register/RegisterTemplate';
/**
 * @page Register.tsx
 * @description Main register page.
 * @return { page }
 */
function Register() {
  return <RegisterTemplate />;
}

export default Register;
